// ShowModel.jsx

/* eslint-disable react-hooks/exhaustive-deps */
import { toArray } from 'lodash';
import { useCallback, useEffect, useState } from 'react';
import { Button, Col, Form, Modal, Row, Tab, Table, Tabs } from 'react-bootstrap';
import CommonApiService from '../../../services/CommonApiService';
import SweetAlertService from '../../../services/SweetAlertService';
import { useD1Approval } from './ContextAPI';
import ShowTable from './ShowTable';
import LoaderSubmit from '../../LoaderSubmit';

const MONTH_NAMES = {
    1: 'January',
    2: 'February',
    3: 'March',
    4: 'April',
    5: 'May',
    6: 'June',
    7: 'July',
    8: 'August',
    9: 'September',
    10: 'October',
    11: 'November',
    12: 'December',
};

export default function ShowModel() {
    const {
        show,
        setShow,
        rowData,
        addD1Approval,
        receiveData,
        setReceiveData,
        setReceiveList,
        isSubmitted,
        setIsSubmitted,
    } = useD1Approval();
    const { drugCategory, getDrugCategory } = CommonApiService();
    const { submitConfirmSwal } = SweetAlertService();
    const [page, setPage] = useState(0);
    const [pageLength, setPageLength] = useState(0);

    useEffect(() => {
        const newList = {};

        rowData?.records?.forEach((el) => {
            const itemdata = {};
            itemdata.drug_id = el.drug_id;
            itemdata.d1_details_id = el.d1_details_id;
            itemdata.requested_qty = el.requested_qty;
            itemdata.approved_request_qty =
                Number(el.approved_request_qty) > 0 ? el.approved_request_qty : el.requested_qty;
            itemdata.remarks = el.remarks;

            if (itemdata.drug_id !== '') {
                newList[itemdata.drug_id] = itemdata;
            }
        });

        setReceiveData(newList);
        setReceiveList(toArray(newList));
    }, [rowData.records]);

    const dataList = useCallback(() => {
        getDrugCategory();
    }, []);

    useEffect(() => {
        dataList();
    }, [dataList]);

    useEffect(() => {
        setPageLength(drugCategory?.length);
    }, [drugCategory]);

    const handleClose = () => {
        setShow(false);
    };

    const tableDataDisplay = () =>
        drugCategory?.map((item, index) => (
            <Tab key={item.id} eventKey={index} title={item.name}>
                <ShowTable
                    data={rowData?.records?.filter(
                        (el) => Number(el.category_id) === Number(item.id)
                    )}
                />
            </Tab>
        ));

    const submitHandler = async () => {
        const isConfirmed = await submitConfirmSwal();

        if (!isConfirmed) {
            return;
        }

        setIsSubmitted(true);
        const data = {
            d1_master_id: rowData.d1_master_id,
            medicine_lists: toArray(receiveData),
        };
        addD1Approval(data);
    };

    return (
        <Modal className="modalWidth80" show={show} onHide={handleClose}>
            <Modal.Header closeButton>
                <Modal.Title>Facility Internal Request Details</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Form>
                    <Row>
                        <Col>
                            <Table bordered hover size="sm">
                                <thead className="table-light">
                                    <tr>
                                        <th>Facility Name</th>
                                        <th>Month</th>
                                        <th>Year</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <td>{rowData?.facility_name}</td>
                                        <td>{MONTH_NAMES[Number(rowData?.month)] || ''}</td>
                                        <td>{rowData?.year}</td>
                                    </tr>
                                </tbody>
                            </Table>
                        </Col>
                    </Row>
                    <Row>
                        <Tabs
                            activeKey={page}
                            transition={false}
                            id="noanim-tab-example"
                            className="mb-3"
                            // eslint-disable-next-line radix
                            onSelect={(k) => setPage(parseInt(k))}
                        >
                            {tableDataDisplay()}
                        </Tabs>
                    </Row>

                    <Modal.Footer className="borderTop0 pe-0">
                        <Button className="btnCancel" variant="secondary" onClick={handleClose}>
                            Close
                        </Button>
                        <Button
                            className={`btnInfo me-2 ms-2 ${page === 0 && 'd-none'}`}
                            variant="primary"
                            style={{ minWidth: '6rem' }}
                            disabled={page === 0}
                            onClick={() => {
                                setPage((currPage) => currPage - 1);
                            }}
                        >
                            Prev
                        </Button>
                        <Button
                            type="button"
                            className={`btnSuccess ${rowData.status === 'd1_prepared' &&
                                page === pageLength - 1 &&
                                'd-none'
                                }`}
                            variant="success"
                            disabled={page === pageLength}
                            style={{ minWidth: '6rem' }}
                            onClick={() => setPage((currPage) => currPage + 1)}
                        >
                            Next
                        </Button>
                        {rowData.status === 'd1_prepared' && (
                            <Button
                                onClick={submitHandler}
                                className={`btnSuccess ${page !== pageLength - 1 && 'd-none'}`}
                                type="button"
                                variant="success"
                                style={{ minWidth: '6rem' }}
                                disabled={isSubmitted}
                            >
                                Submit
                            </Button>
                        )}
                        {isSubmitted && <LoaderSubmit />}
                    </Modal.Footer>
                </Form>
            </Modal.Body>
        </Modal>
    );
}